import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { findActiveMenuItem } from '../../helpers';
import { IRootState } from '../../types/store';
import { CustomerAppDatagrid } from '../../components/DataGrid/CustomerApp';

export const CustomerAppPage = () => {
  const location = useLocation();
  const { section: sectionParam } = useParams<{ section?: string }>();
  const menuItems = useSelector((state: IRootState) => state.user.menuItems);

  const activeSubMenu = useMemo(
    () => findActiveMenuItem(menuItems, location.pathname),
    [menuItems, location.pathname],
  );

  const headerTitles: Record<string, { section: string; headerLabel: string }> = {
    'FLASH DEALS': {
      section: 'flashdeals',
      headerLabel: 'Flash Sale Products',
    },
    POPULAR: {
      section: 'popular',
      headerLabel: 'Popular Stuff Products',
    },
    FESTIVAL: {
      section: 'festival',
      headerLabel: 'Specials this Week Products',
    },
    TRENDING: {
      section: 'trending',
      headerLabel: 'Discover Products',
    },
    'NEW ARRIVAL': {
      section: 'newarrival',
      headerLabel: 'New Arrival Products',
    },
  };

  const sectionTitle = activeSubMenu?.title?.toUpperCase() ?? '';
  const headerConfig = headerTitles[sectionTitle];

  return (
    <CustomerAppDatagrid
      section={headerConfig?.section ?? sectionParam ?? ''}
      headerLabel={headerConfig?.headerLabel ?? sectionParam ?? ''}
    />
  );
};
